import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Axios from 'axios'
import VueTreeList from 'vue-tree-list'
import VueEasyLightbox from 'vue-easy-lightbox'
import introJS from 'intro.js';
import 'intro.js/introjs.css';
import './registerServiceWorker'

Vue.use(VueEasyLightbox);
Vue.use(VueTreeList);
Vue.config.productionTip = false;

Vue.filter('filterBirthday', function (birthday) {
    if (!birthday) return ''
    return new Date(birthday).toLocaleDateString();
})

function plural(number, titles) {
    let cases = [2, 0, 1, 1, 1, 2];

    return `${number} ${titles[ (number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5] ]}`
}

Vue.filter('calculateAge', function (birthday) {
    if (!birthday) return ''

    let today = new Date(),
        birthDate = new Date(birthday);

    let age = today.getFullYear() - birthDate.getFullYear(),
        m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }

    return plural(age, ['год', 'года', 'лет']);
})

Vue.filter('calculateAgeByDays', function (days) {
    if (!days) return 0

    let years = (days/365).toFixed(1),
        yearsArray = years.split('.' || ','),
        year = +yearsArray[0],
        month = +yearsArray[1];

        // Если есть возраст
        if(year && year > 0) {
            year = plural(yearsArray[0], ['год', 'года', 'лет']);
        }
        
        // Если есть кол-во месяцев
        if(month && month > 0) {
            month = plural(yearsArray[1], ['месяц', 'месяца', 'месяцев']);
        }

    return `${year ? year : ''} ${month ? month : ''}`;
})

Vue.prototype.introJS = introJS().setOptions({
    exitOnOverlayClick: false,
    showBullets: false,
    exitOnEsc: false,
    nextLabel: 'Далее',
    prevLabel: 'Назад',
    doneLabel: 'Хорошо'
});

Vue.prototype.$http = Axios;

const token = localStorage.getItem('token')

if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
